<template>
  <!-- Category section -->

  <div id="cate-toggle" class="category-menu">
    <div class="category-heading-custom">
      <h2>Categories</h2>
    </div>
    <div class="category-menu-list">
      <ul>
        <li class="font-weight-bold cat-all">
          <router-link to="/shop">{{ all }}</router-link>
        </li>
        <li
          v-for="(famille, key) in menus"
          :key="key"
          :class="{ 'right-menu': famille.get_sous_famille.length > 0 }"
        >
          <router-link
            :to="
              '/shop/' +
              (JSON.parse(famille.obj_nom)[locale]
                ? JSON.parse(famille.obj_nom)[locale]
                : '###')
            "
            ><img
              class="menu-icon"
              src="/images/icons/icon_menu.png"
              alt="icon"
            />{{
              JSON.parse(famille.obj_nom)[locale]
                ? JSON.parse(famille.obj_nom)[locale]
                : "###"
            }}</router-link
          >
          <!-- <ul v-if="cat.mega" class="cat-mega-menu">
                      <li v-for="menu in cat.sub" :key="menu.title" class="right-menu cat-mega-title mt-3">
                        <router-link to="/shop">{{ menu.title }}</router-link>
                        <ul>
                          <li v-for="item in menu.items" :key="item"><router-link to="/shop">{{item}}</router-link></li>
                        </ul>
                      </li>
                    </ul> -->
          <ul class="cat-dropdown" v-if="famille.get_sous_famille.length > 0">
            <li>
              <router-link
                v-for="(sf, keySf) in famille.get_sous_famille"
                :key="keySf"
                :to="
                  '/shop/' +
                  (JSON.parse(famille.obj_nom)[locale]
                    ? JSON.parse(famille.obj_nom)[locale]
                    : '###') +
                  '/' +
                  (JSON.parse(sf.obj_nom)[locale]
                    ? JSON.parse(sf.obj_nom)[locale]
                    : '###')
                "
                >{{
                  JSON.parse(sf.obj_nom)[locale]
                    ? JSON.parse(sf.obj_nom)[locale]
                    : "###"
                }}</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <!-- End Category section -->
</template>

<script>
export default {
  name: "Categories",
  data() {
    return {
      shopName: "shop",
    };
  },
  methods: {
    goToShop() {
      if (this.$route.name !== this.shopName) {
        this.$router.push({ name: this.shopName });
      }
    },
    reinitFilter() {
      this.$store.dispatch("cotation/reinitFilterSousFamille");
    },
    addToFilter(idSF) {
      let self = this;
      var objExiste = _.find(self.sf, (id) => id === idSF);

      if (!objExiste) {
        self.sf.push(idSF);
      } else {
        var index = _.findIndex(self.sf, (id) => id === idSF);
        self.sf.splice(index, 1);
      }
    },

    addSousFamille(idSF) {
      this.reinitFilter();
      this.addToFilter(idSF);
      this.sf = this.sf;
      this.goToShop();
    },
  },
  computed: {
    all() {
      let str = this.locale == "fr" ? "Tous les articles" : "All articles";
      return str.toUpperCase();
    },
    menus() {
      return this.$store.getters["cotation/menus"];
    },
    sf: {
      get() {
        return this.$store.getters["cotation/filters"].sf;
      },
      set(value) {
        this.$store.dispatch("cotation/setFilterSousFamille", { sf: value });
      },
    },
    locale() {
      return this.$store.getters["configapp/locale"];
    },
  },
};
</script>

<style scoped>
.cat-all {
  padding: 0.2rem 0;
  /* background-color: rgba(171, 140, 85, 0.062);
  transition: background-color .4s ease-out; */
}
/* .cat-all:hover {
  background-color: rgba(171, 140, 85, 0.164);
} */

.menu-icon {
  height: 25px;
  padding: 0.3rem;
}
</style>
